var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 26 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4129 33.7134L23.7685 30.1718C25.7183 29.233 26.275 26.3468 25.355 24.436L15.0819 3.10016C14.1622 1.18997 11.8359 0.40103 9.88613 1.33983L2.53052 4.8815C0.581372 5.82 -0.254079 8.13052 0.665959 10.0413L10.939 31.3772C11.8603 33.2874 14.4637 34.6519 16.4129 33.7134ZM9.31318 26.4178L5.87004 19.2668L7.47351 18.2297L8.89209 21.1759L9.31318 26.4178ZM10.0931 22.1948C10.0931 22.1948 10.7013 25.3832 11.2169 28.08C17.8915 27.1286 22.5381 22.6621 22.6064 22.5964L22.6072 22.5957L18.7054 18.0481L10.0931 22.1948ZM18.5449 16.2903L17.219 13.5366L19.0297 12.9283L22.381 19.8886L18.5449 16.2903ZM18.5211 11.8721L15.4635 5.52172L14.293 7.45967L16.7122 12.484L18.5211 11.8721ZM13.6205 4.18591L13.2178 6.89901L4.60362 11.0467L2.23089 9.66994L13.6205 4.18591ZM6.96317 17.1698L4.6396 12.3441L2.39503 12.0497L5.36088 18.2094L6.96317 17.1698Z",
    fill: "#404080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.90a41c429dd5cdcd9d688639724fd20e.svg";
export { ForwardRef as ReactComponent };